<template>
  <div class='massLoss-list'>
    <el-row>
      <div class='tabs'>
        <div @click='typeFun(0)' class='left' :class='{ active: dataType === 0 }'>实时数据</div>
        <div @click='typeFun(1)' class='right' :class='{ active: dataType === 1 }'>历史数据</div>
      </div>
    </el-row>
    <div class='nav'>
      <el-form ref='ruleForm' :model='searchForm' label-width='80px' :inline='true'
               class='demo-form-inline flex1' :rules='rules'>
        <el-form-item label='年月：' prop='time'>
          <el-date-picker v-model='searchForm.time' type='month' size='mini'
                          :clearable='false'
                          style='width:150px' value-format='yyyy-MM' @change='dateChange'
                          placeholder='开始日期' />
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button v-if='dataType === 0' size='small' type='primary' :loading='saveLoading'
                     @click='dataSave'>保存
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          ref='registerTable'
          v-loading='tableLoading'
          :data='tableData'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
          :span-method='objectSpanMethod'
        >

          <el-table-column :label='`${year}年${month}月江运量及收入完成情况统计分析表`' align='center'>
            <el-table-column label='（收入单位：人民币万元；运量单位：集装箱量-TEU、商品车量-辆、干散货量-吨）' align='left'>
              <el-table-column label='项目' align='center'>
                <el-table-column prop='company' label='业务公司' align='center' min-width='100px' />
              </el-table-column>
              <el-table-column label='' align='center'>
                <el-table-column prop='type' label='流向' align='center' min-width='100px'>
                  <template slot-scope='scope'>
                    {{
                      scope.row.type === 0 ? '下水' : scope.row.type === 1 ? '上水' : scope.row.type === 2 ? '全线' : '--'
                    }}
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label='' align='center'>
                <el-table-column label='类别' align='center' min-width='100px'>
                  <template slot-scope='scope'>
                    {{ scope.row.carOrEarn === 0 ? '车' : '收入' }}
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label='本月情况' align='center'>
                <el-table-column prop='monthTransportCount' label='本月运量' align='center'
                                 min-width='100px' :formatter='numberFormat' />
                <el-table-column prop='monthEarnings' label='本月收入' align='center'
                                 min-width='100px' :formatter='numberFormat' />
                <el-table-column prop='monthPlanTransportCount' label='月计划运量' align='center'
                                 min-width='100px' :formatter='numberFormat' />
                <el-table-column prop='monthPlanTransportCountCompletionRate' label='月计划运量完成率'
                                 align='center' min-width='140px' />
                <el-table-column prop='monthPlanEarnings' label='月计划收入' align='center'
                                 min-width='100px' :formatter='numberFormat' />
                <el-table-column prop='monthPlanEarningsCountCompletionRate' label='月计划收入完成率'
                                 align='center' min-width='140px' />
                <el-table-column prop='monthEarningsProportion' label='收入比重' align='center'
                                 min-width='100px' :formatter='earningsProportionFormat' />
                <el-table-column prop='transportCountIncrease' label='运量环比增加%' align='center'
                                 min-width='140px' />
                <el-table-column prop='earningsIncrease' label='收入环比增加%' align='center'
                                 min-width='140px' />
              </el-table-column>
              <el-table-column label='全年累计情况' align='center'>
                <el-table-column prop='yearTransportCount' label='本期运量' align='center'
                                 min-width='100px' :formatter='numberFormat' />
                <el-table-column prop='yearEarnings' label='本期收入' align='center'
                                 min-width='100px' :formatter='numberFormat' />
                <el-table-column prop='yearPlanTransportCount' label='年计划运量' align='center'
                                 min-width='100px' :formatter='numberFormat' />
                <el-table-column prop='yearPlanTransportCountCompletionRate' label='年计划运量完成率'
                                 align='center' min-width='140px' />
                <el-table-column prop='yearPlanEarnings' label='年计划收入' align='center'
                                 min-width='100px' :formatter='numberFormat' />
                <el-table-column prop='yearPlanEarningsCountCompletionRate' label='年计划收入完成率'
                                 align='center' min-width='140px' />
                <el-table-column prop='yearEarningsProportion' label='收入比重' align='center'
                                 min-width='100px' :formatter='earningsProportionFormat' />
              </el-table-column>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    riverTransportationReportHistoricalData,
    riverTransportationReportPage, riverTransportationReportSave,
  } from '@/service/financial';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';

  export default {
    name: 'riverTransportationReport',
    data() {
      return {
        dataType: 0,
        saveLoading: false,
        searchForm: {
          time: '',
        },
        defaultSearchForm: {},
        rules: {
          time: {
            required: true,
            message: '请选择月份',
            trigger: 'blur',
          },
        },
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        year: '',
        month: '',
      };
    },
    mounted() {
      this.getDefaultYear();
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      this.searchBtn();
    },
    methods: {
      typeFun(val) {
        this.dataType = val;
        this.searchBtn();
      },
      earningsProportionFormat(row, column, cellValue) {
        if (!cellValue && cellValue !== 0) return '';
        return cellValue ? cellValue + '%' : cellValue;
      },
      numberFormat(row, column, cellValue) {
        if (!cellValue && cellValue !== 0) return '';
        let str = cellValue.toString();
        let reverse_str = str.split('')
          .reverse()
          .join('');
        let arr = [];
        for (let i in reverse_str) {
          if (i % 3 === 0) {
            arr.push(reverse_str.substr(i, 3)
              .split('')
              .reverse()
              .join(''));
          }
        }
        return arr.reverse()
          .join(',');
      },
      // 结束时间
      dateChange(val) {
        this.year = val.split('-')[0];
        this.month = val.split('-')[1];
        this.searchBtn();
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/riverTransportationReport/export?access_token=${token}&time=${this.searchForm.time}`;
        window.exportExcelGet('/platform/riverTransportationReport/export', `time=${this.searchForm.time}`)
      },
      async dataSave() {
        this.saveLoading = true;
        const {
          status,
          message,
        } = await riverTransportationReportSave(this.searchForm);
        this.saveLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        this.searchBtn();
      },
      // 查询
      searchBtn() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.searchForm.page = 1;
            this.dataType === 0 ? await this.getTableData() : await this.getHistoricalData();
          }
        });
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await riverTransportationReportPage(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) {
          this.tableData = [];
          return this.$message.warning(message);
        }
        this.tableData = data;
      },
      // 获取表格数据
      async getHistoricalData() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await riverTransportationReportHistoricalData(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) {
          this.tableData = [];
          return this.$message.warning(message);
        }
        this.tableData = data;
      },
      getDefaultYear() {
        const date = new Date();
        this.year = date.getFullYear();
        this.month = (date.getMonth() + 1).toString()
          .padStart(2, '0');
        this.searchForm.time = this.year + '-' + this.month;
      },
      // 合并相同列
      objectSpanMethod({
                         row,
                         column,
                         rowIndex,
                         columnIndex,
                       }) {
        // data ：需要修改的列数和列的属性 第一列从0开始
        const data = [
          {
            columnIndex: 0,
            value: 'company',
          },
          {
            columnIndex: 1,
            value: 'type',
          },
        ];
        for (let index = 0; index < data.length; index++) {
          if (columnIndex === data[index].columnIndex) {
            const _row = this.filterData(this.tableData, data[index].value)[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
              rowspan: _row,
              colspan: _col,
            };
          }
        }
      },
      // 根据是否有相同数据返回一个如[2,0,3,0,0]格式的数组(公共的)
      filterData(arr, value) {
        let spanOneArr = [];
        let concatOne = 0;
        arr.forEach((item, index) => {
          if (index === 0) {
            spanOneArr.push(1);
          } else {
            // name 修改
            if (item[value] === arr[index - 1][value]) {
              spanOneArr[concatOne] += 1;
              spanOneArr.push(0);
            } else {
              spanOneArr.push(1);
              concatOne = index;
            }
          }
        });
        return spanOneArr;
      },
    },
  };
</script>


<style lang='scss' scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/

    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 240px;
      margin-bottom: 20px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599E;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599E;
        font-weight: 700;
        transition: all .3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .right {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }

      .active {
        background: #48599E;
        color: #fff;
      }
    }

    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      height: 60px;
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }


        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }


    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }

            }

          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }

        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }

    }

  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      margin-right: 10px;
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
